"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenshotAnimation = void 0;
var ScreenshotAnimation = /** @class */ (function () {
    function ScreenshotAnimation(frame) {
        var _a;
        this.frame = frame;
        this.interval = 3500;
        this.transition = 700;
        this.index = 0;
        this.totalSlides = 0;
        this.isPaused = false;
        var slider = frame.querySelector('.screenshot__slider');
        if (!slider) {
            throw new Error('Screenshot slider not found.');
        }
        this.slider = slider;
        this.button = (_a = frame.querySelector('.screenshot__control')) !== null && _a !== void 0 ? _a : undefined;
        this.init();
    }
    ScreenshotAnimation.prototype.init = function () {
        var _this = this;
        var _a, _b;
        var slides = Array.from(this.slider.children);
        if (slides.length <= 1) {
            (_a = this.button) === null || _a === void 0 ? void 0 : _a.remove();
            return;
        }
        this.slider.appendChild(slides[0].cloneNode(true));
        this.totalSlides = this.slider.children.length;
        this.slider.classList.add('is-animated');
        (_b = this.button) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () { return _this.toggle(); });
        this.start();
    };
    ScreenshotAnimation.prototype.start = function () {
        var _this = this;
        if (this.timer) {
            return;
        }
        this.isPaused = false;
        this.updateButton();
        this.timer = window.setInterval(function () {
            _this.next();
        }, this.interval);
    };
    ScreenshotAnimation.prototype.stop = function () {
        this.isPaused = true;
        if (this.timer !== undefined) {
            window.clearInterval(this.timer);
            this.timer = undefined;
        }
        this.updateButton();
    };
    ScreenshotAnimation.prototype.toggle = function () {
        this.isPaused ? this.start() : this.stop();
    };
    ScreenshotAnimation.prototype.updateButton = function () {
        if (!this.button) {
            return;
        }
        this.button.setAttribute('aria-pressed', String(this.isPaused));
        var playIcon = this.button.querySelector('.screenshot__control-play-icon');
        var pauseIcon = this.button.querySelector('.screenshot__control-pause-icon');
        var playText = this.button.querySelector('.screenshot__control-text--play');
        var pauseText = this.button.querySelector('.screenshot__control-text--pause');
        if (playIcon) {
            playIcon.hidden = !this.isPaused;
        }
        if (pauseIcon) {
            pauseIcon.hidden = this.isPaused;
        }
        if (playText) {
            playText.hidden = !this.isPaused;
        }
        if (pauseText) {
            pauseText.hidden = this.isPaused;
        }
    };
    ScreenshotAnimation.prototype.next = function () {
        var _this = this;
        if (this.isPaused) {
            return;
        }
        this.index++;
        this.slider.style.transform = "translateX(-".concat(this.index * 100, "%)");
        if (this.index === this.totalSlides - 1) {
            window.setTimeout(function () {
                _this.slider.classList.remove('is-animated');
                _this.slider.style.transform = 'translateX(0)';
                _this.index = 0;
                void _this.slider.offsetWidth;
                _this.slider.classList.add('is-animated');
            }, this.transition);
        }
    };
    return ScreenshotAnimation;
}());
exports.ScreenshotAnimation = ScreenshotAnimation;
